<template>
  <div v-if="visible" class="announcement-banner-component">
    <div class="announcement-content">
      <KmIcon name="km-icon-mcp" :size="18" class="mr-2" />
      <span>
        <b>New — MCP integration:</b> connect Claude, Cursor or any AI assistant to your PM2.io
        monitoring data.
      </span>
      <VBtn
        v-if="mcpRoute"
        :to="mcpRoute"
        small
        round
        outline
        color="white"
        class="my-0 ml-3"
        @click.native="dismiss"
      >
        Discover
      </VBtn>
    </div>
    <VBtn small icon class="close-button ma-0" title="Dismiss" @click="dismiss">
      <KmIcon name="km-icon-close" :size="10" />
    </VBtn>
  </div>
</template>

<script>
import KmIcon from '@/components/KmIcon'
import { MCP_PAGE } from '@/router'
import { BACKEND_APP_TYPE } from '@/config/appTypes'

const STORAGE_KEY = 'hasDismissedMcpAnnouncement'

export default {
  name: 'AnnouncementBanner',

  components: {
    KmIcon,
  },

  data() {
    return {
      dismissed: window.localStorage.getItem(STORAGE_KEY) === 'true',
    }
  },

  computed: {
    visible() {
      return !this.dismissed
    },
    mcpRoute() {
      const bucketId = this.$store.getters.currentBucketId
      if (!bucketId) return null
      return {
        name: MCP_PAGE,
        params: {
          id: bucketId,
          appType: this.$store.getters.currentAppType || BACKEND_APP_TYPE,
        },
      }
    },
  },

  methods: {
    dismiss() {
      window.localStorage.setItem(STORAGE_KEY, 'true')
      this.dismissed = true
    },
  },
}
</script>

<style lang="postcss" scoped>
.announcement-banner-component {
  /* Deep purple sampled from the PM2 logo */
  --announcementBg: #711dcb;

  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 4px 48px;
  background-color: var(--announcementBg);
  color: #fff;

  & .announcement-content {
    display: flex;
    align-items: center;
    text-align: center;
  }

  & .close-button {
    position: absolute;
    right: 8px;
  }
}
</style>
